import { SortType } from 'features/shared/enums';
import { Dispatch, SetStateAction } from 'react';

export type ID = undefined | null | number | string;

export type MODAL_VIEWS = 'VIEW' | 'CHANGE_PASSWORD' | 'ASSIGN_EMPLOYEE' | 'CONFIRM_MODAL' | 'VIEW_EDIT';

export type ItemData =
  | {
      id?: ID;
      view: MODAL_VIEWS;
      data?: any;
    }
  | undefined;

export type ItemWithId = {
  id?: ID;
};

export const defaultItemsPerPage = 30;
export type Link = { label: string; active: boolean; url: string | null; page: number | null };
export type PaginationState = {
  page: number;
  items_per_page: number;
  links?: Array<Link>;
};

export type SortState = {
  sort?: string;
  order?: SortType;
};

export type FilterState = {
  filter?: unknown;
};

export type SearchState = {
  search?: string;
};

export type Response<T> = {
  totalCount?: number;
  data?: T;
  payload?: {
    pagination?: PaginationState;
  };
};

export type QueryState = PaginationState & SortState & FilterState & SearchState;

export type QueryRequestContextProps = {
  state: QueryState;
  updateState: (updates: Partial<QueryState>) => void;
};

export const initialQueryState: QueryState = {
  page: 1,
  items_per_page: defaultItemsPerPage
};

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {
    // empty
  }
};

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined;
  refetch: () => void;
  isLoading: boolean;
  query: string;
};

export const initialQueryResponse = {
  refetch: () => {
    // empty
  },
  isLoading: false,
  query: ''
};

export type ListViewContextProps = {
  selected: Array<ID>;
  onSelect: (selectedId: ID) => void;
  onSelectSingle: (selectedId: ID) => void;
  onSelectAll: () => void;
  clearSelected: () => void;
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ItemData;
  setItemIdForUpdate: Dispatch<SetStateAction<ItemData>>;
  isAllSelected: boolean;
  disabled: boolean;
  expandedRowIds?: Array<ID>;
  setExpandedRowIds: Dispatch<SetStateAction<Array<ID> | undefined>>;
};

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {
    // empty
  },
  onSelectAll: () => {
    // empty
  },
  onSelectSingle: () => {
    // empty
  },
  clearSelected: () => {
    // empty
  },
  setItemIdForUpdate: () => {
    // empty
  },
  setExpandedRowIds: () => {
    // empty
  },
  isAllSelected: false,
  disabled: false
};
